import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {select, Store} from "@ngrx/store";
import * as fromQuote from '../../reducers/index';
import * as layoutActions from '../../../core/actions/layout.actions';
import {Observable} from "rxjs";
import * as QuoteActions from "../../actions/quote.action";
import {AbstractQuoteComponent} from "../abstract-quote/abstract-quote.component";
import {MatDialog} from '@angular/material/dialog';
import {
    ConfirmationDialogComponent
} from "../../../shared/components/confirmation-dialog/confirmation-dialog.component";

@Component({
    selector: 'create-new-quote-from-root-landing',
    templateUrl: './create-new-quote-from-root-landing.component.html',
    styleUrls: ['./create-new-quote-from-root-landing.component.scss']
})

// Pretty much a duplicate of the quote-detail component...This can be handled in a better way
export class CreateNewQuoteFromRootComponentLanding extends AbstractQuoteComponent implements OnInit {
    readonly deleteQuoteMessageTextId = 'quote-detail_delete-quote-confirmation-message';
    readonly deleteQuoteProductMessageTextId = 'quote-detail_delete-quote-product-confirmation-message';

    editQuote$: Observable<boolean>;

    quoteName: string

    @Output()
    deselectQuote = new EventEmitter<void>();

    @Output()
    close = new EventEmitter();

    constructor(protected dialog: MatDialog, private store: Store<fromQuote.State>) {
        super()
    }

    ngOnInit() {
        this.editQuote$ = this.store.pipe(select(fromQuote.getQuoteEdit));
        this.quoteName = this.trimQuoteName(this.quote.name);
    }

    onCloseMenu() {
        this.close.emit();
    }

    editQuote() {
        this.store.dispatch(QuoteActions.openEditQuote());
    }


    onDeselectQuote() {
        console.log("Here")
        this.deselectQuote.emit();
    }

    openDeleteConfirmationDialog(event: Event): void {
        if (event) {
            event.stopPropagation();
        }

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: `${this.dialogWidthPx}px`,
            data: {
                subheader: this.quote.name,
                message: this.i18nDictionary.get(this.deleteQuoteMessageTextId)
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.deleteQuote.emit(this.quote);
            }
        });
    }

    protected onQuoteBarItemChanged(): void {
        if (this.quoteBarItem.isPending) {
            return;
        }

        if (this.quoteBarItem.quote != undefined) {
            this.quoteName = this.trimQuoteName(this.quoteBarItem.quote.name);
        }
    }

    private trimQuoteName(quoteName: string): string {
        if (this.quote.name.length > 18) {
            return `${quoteName.split("").splice(18).join("")}...`;
        }
        return quoteName;
    }
}
